/* eslint-disable react-native/no-inline-styles */
import React, { useState } from 'react';
import { Button, Dialog, Text, TextInput, Portal } from 'react-native-paper';
import { theme } from '../../theme/theme';

const StockModal = ({ visible, closeModal, item, onUpdateStock }) => {
  const [tempStock, setTempStock] = useState(item?.stock_qty || 0);
  const MAX_STOCK = 999;

  const handleUpdate = () => {
    onUpdateStock(Number(tempStock));
    closeModal();
  };

  return (
    <Portal>
      <Dialog visible={visible} onDismiss={closeModal} style={{ borderRadius: 12 }}>
        <Dialog.Title style={{ color: theme.colors.primary }}>
          Update Stock
        </Dialog.Title>
        <Dialog.Content>
          <Text style={{ fontWeight: '600', marginBottom: 12 }}>
            Item - {item?.item_name}
          </Text>

          <TextInput
            value={String(tempStock)}
            onChangeText={(val) => {
              const num = parseInt(val, 10) || 0;
              if (num <= MAX_STOCK) {
                setTempStock(num);
              } else {
                setTempStock(MAX_STOCK);
              }
            }}
            keyboardType="numeric"
          />
        </Dialog.Content>

        <Dialog.Actions>
          <Button onPress={closeModal}>Cancel</Button>
          <Button onPress={handleUpdate}>Update</Button>
        </Dialog.Actions>
      </Dialog>
    </Portal>
  );
};

export default StockModal;
